module.exports = __webpack_public_path__ + "img/im_scrollfeature_11@2x.f738df36.jpg";